<template>
  <section>
    <h2 class="h2Title">모임 등록</h2>
    <div class="formInfo">
      <v-form ref="formMeeting">
        <dl class="infoCont">
          <dt class="formInfoTxt">모임 분류 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="d-flex">
              <ul v-for="(t) in rootGroups" :key="t.groupId">
                <v-checkbox v-model="meeting.group.parentId" :value="t.groupId" :label="t.groupName" hide-details :rules="[rules.required]"
                            @change="meeting.groupId = null" v-if="t.activated" />
              </ul>
              <v-col class="mgr" style="max-width: 10px">
              </v-col>
              <v-col class="mgr" sm="2">
                <v-select :items="departmentItems" item-value="groupId" item-text="groupName" v-model="meeting.groupId"
                          dense clearable outlined flat required label="선택" :rules="[rules.required]" v-if="meeting.group.parentId === 1"/>

                <v-select :items="clubItems" item-value="groupId" item-text="groupName" v-model="meeting.groupId"
                          dense clearable outlined flat required label="선택" :rules="[rules.required]" v-if="meeting.group.parentId === 2"/>
              </v-col>

            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt">제목 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="meeting.title" :rules="[rules.required]" label="" dense flat
                            clearable/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt">장소</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="meeting.place" label="" dense flat clearable/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt">주소</dt>
          <dd class="formInfoArea">

            <v-col>
              <v-col class="mgr d-flex">
                <v-text-field type="number" v-model="meeting.zipCode" label="우편번호"
                              @click="openZipCode"
                              v-on:keyup.13="openZipCode"
                              maxlength="6"
                              :rules="[
                                      value => !value || (value.length >= 5 && value.length <= 6) || '우편번호 형식이 아닙니다.\n\r5~6자리 숫자로 입력해주세요.'
                                      ]"/>
                <v-text-field v-model="meeting.address" label="주소" />
              </v-col>
              <v-col class="mgr">
                <v-text-field v-model="meeting.addressDetail" label="주소상세"></v-text-field>
              </v-col>
            </v-col>
            <v-dialog v-model="daumDialogVisible" max-width="500px" @click:outside="daumDialogVisible=false" @keydown.esc="daumDialogVisible=false">
              <daum-post @complete="completeZipCode" />
            </v-dialog>
          </dd>
          <dt class="formInfoTxt">지도 상세</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6" v-if="meeting.lon && geos && geos.length > 1">
              <v-select :items="geos"
                        v-model="geo"
                        return-object
                        label="검색결과" item-text="roadAddress"
                        dense solo flat clearable
                        outlined
                        @change="setGeo"
              />
            </v-col>
            <v-col class="mgr" sm="6" v-if="meeting.lon">
              <img :src="`https://naveropenapi.apigw.ntruss.com/map-static/v2/raster-cors?w=300&h=300&center=${ meeting.lon },${ meeting.lat }&markers=markers=type:d|size:mid|pos:${ meeting.lon }%20${ meeting.lat }&level=16&X-NCP-APIGW-API-KEY-ID=${ $store.state.config.ext.naver.staticmap.id }`">
            </v-col>
            <v-col v-else-if="!meeting.lon && meeting.address" e>좌표를 찾을 수 없습니다.</v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt">예상인원</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="2">
              <v-text-field v-model="meeting.estimateNumber" label="" dense flat/>
            </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt">일정 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
          <dd class="formInfoArea d-flex">

              <v-col class="mgr" sm="2">
                <v-menu
                    v-model="startCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="meeting.startDt"
                        label="모임 시작일"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="meeting.startDt"
                      @input="setStartDt"
                      locale="ko"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="mgr d-flex" style="max-width: 120px;  margin-top: 30px">
                <v-img><v-icon>mdi-clock-outline</v-icon></v-img>
                <vue-timepicker manual-input v-model="meeting.startTm" :input-class="errStartTm ? 'invalid' : ''" :minute-interval="10" auto-scroll
                @change="setStartTm"/>
                <v-input hidden v-model="meeting.startTm"></v-input>
              </v-col>
              <v-col class="mgr align-center " style="max-width: 20px; margin-top: 10px">
                ~
              </v-col>
              <v-col class="mgr" sm="2">
                <v-menu
                    v-model="endCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="meeting.endDt"
                        label="모임 종료일"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="meeting.endDt"
                      @input="endCal = false"
                      locale="ko"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="mgr d-flex"  style="max-width: 120px;  margin-top: 30px">
                <v-img><v-icon>mdi-clock-outline</v-icon></v-img>
                <vue-timepicker manual-input v-model="meeting.endTm" :input-class="errEndTm ? 'invalid' : ''" :minute-interval="10" auto-scroll></vue-timepicker>
                <v-input hidden v-model="meeting.endTm"></v-input>
              </v-col>
          </dd>
        </dl>
        <dl class="infoCont">
          <dt class="formInfoTxt">모임비</dt>
          <dd class="formInfoArea">
              <v-switch
                  v-model="hasEntryFee"
                  flat
                  color="primary"
                  :label="hasEntryFee ? '있음' : '없음'"
                  style="margin-top: 10px; padding-right: 10px"
              ></v-switch>
            <v-col class="mgr d-flex" sm="1">
              <v-text-field v-model="meeting.entryFee" :rules="[!hasEntryFee || rules.required, !hasEntryFee || rules.qtZero]" label=""
                            dense flat /> <span style="padding-top: 20px">원</span>
            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt">상세내용</dt>
          <dd class="formInfoArea">
            <v-col class="mgr">
              <editor-component
                  ref="meetingContents"
                  :val="meeting.meetingContents"
                  :uploaded="fileMeta"
                  @callback-upload="uploadImage"
                  label="상세 내용"/>
            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt">가족동반</dt>
          <dd class="formInfoArea">
            <v-col class="mgr">
              <v-switch
                  v-model="meeting.family"
                  flat
                  color="primary"
                  :label="meeting.family ? '가능' : '불가'"
              ></v-switch>
            </v-col>
          </dd>
        </dl>


        <dl class="infoCont">
          <dt class="formInfoTxt">문의</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-text-field v-model="meeting.askContact" label="" dense flat clearable/>
            </v-col>
          </dd>
        </dl>

        <dl class="infoCont">
          <dt class="formInfoTxt">노출여부</dt>
          <dd class="formInfoArea">
            <v-col class="mgr d-flex" sm="6">
              <v-switch
                  v-model="meeting.activated"
                  flat
                  color="primary"
                  style="padding-top: 15px"
                  :label="meeting.activated ? '노출' : '비노출'"
              ></v-switch>
              <v-spacer style="max-width: 15px"></v-spacer>
              <v-col class="mgr" sm="2" v-if="meeting.activated">
                <v-menu
                    v-model="postCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="meeting.postDt"
                        label="게시일"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="meeting.postDt"
                      @input="postCal = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-col>
          </dd>
          <dt class="formInfoTxt">상태</dt>
          <dd class="formInfoArea">
            <v-col class="mgr" sm="6">
              <v-select :items="stateItems"
                        v-model="meeting.state"
                        item-text="text"
                        item-value="value"
                        dense solo flat clearable
                        placeholder="상태를 선택해주세요."
                        outlined
                        :rules="[rules.required]"
              />
            </v-col>
          </dd>

        </dl>
      </v-form>
    </div>
    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#1991eb" dark @click="save">
          <v-icon left>mdi mdi-content-save</v-icon>
          저장
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goList()">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goSchedule()">
          <v-icon left>mdi mdi-calendar</v-icon>
          일정
        </v-btn>
      </div>
    </div>


  </section>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import meetingApi from '@/api/MeetingApi'
import groupApi from "@/api/GroupApi";
import utilApi from "@/api/UtilApi";

import EditorComponent from "../component/EditorComponent";

// import _ from 'lodash';

export default {
  name: "MeetingForm",
  components: {
    'editor-component': EditorComponent,
    VueTimepicker
  },
  props: {
    id: String
  },
  data: () => ({
    daumDialogVisible: false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      qtZero: value => value && value > 0 || '필수 입력 항목입니다.'
    },
    meeting: {
      title: null,
      zipCode: null,
      address: null,
      meetingContents: null,
      entryFee: 0,
      activated: true,
      group : {
        parentId : 1
      },
      groupId : null,
      lon:null,
      lat:null
    },
    startCal: false,
    endCal: false,
    postCal: false,
    imageFileUrl: null,
    endPoint: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    fileMeta: {},
    rootGroups:[],
    departmentItems:[],
    clubItems:[],
    geos:[],
    errStartTm:false,
    errEndTm:false,
    stateItems:[
      {text:'접수중', value:'STATE_RECEIPT'},
      {text:'접수대기', value:'STATE_READY'},
      {text:'마감', value:'STATE_END'},
      {text:'취소', value:'STATE_CANCEL'}
    ]
  }),
  computed: {
    hasEntryFee: {
      get() {
        return this.meeting.entryFee !== '0';
      },
      set(value) {
        if(!value) {
          this.meeting.entryFee = '0';
        }
      }
    },
    geo() {
      return this.geos.filter(g => g.x === this.meeting.lon && g.y === this.meeting.lat)?.[0]??null
    }
  },
  methods: {
    setGeo(item) {
      this.meeting.lon = item.x
      this.meeting.lat = item.y
    },
    openZipCode() {
      this.daumDialogVisible = true;
      // let _this = this;
      // // eslint-disable-next-line no-undef
      // new daum.Postcode({
      //   oncomplete: function(data) {
      //     // console.log(data);
      //
      //     _this.meeting.zipCode = data.zonecode;
      //     _this.meeting.address = data.address;
      //
      //
      //     utilApi.geo(data.address).then(res => {
      //       if(res.status === 'OK') {
      //         // console.log(res.addresses);
      //
      //         _this.meeting.lon = res.addresses[0]?.x;
      //         _this.meeting.lat = res.addresses[0]?.y;
      //         _this.geos = res.addresses;
      //         // console.log(_this.meeting);
      //       }
      //     });
      //     // console.log(_this.meeting);
      //
      //   }}).open();
    },
    completeZipCode(data) {
      this.meeting.zipCode = data.zonecode
      this.meeting.address = data.address

      utilApi.geo(data.address).then(res => {
        if(res.status === 'OK') {
          // console.log(res.addresses);

          this.meeting.lon = res.addresses[0]?.x;
          this.meeting.lat = res.addresses[0]?.y;
          this.geos = res.addresses;
          // console.log(_this.meeting);
        }
      });

      this.daumDialogVisible = false;
    },
    uploadImage(f) {
      meetingApi.uploadImage(f).then(res => {
        this.fileMeta = res;
      });
    },
    goList() {
      this.$router.push({path: '/group/meeting'})
    },
    goSchedule() {
      this.$router.push({path: '/group/meeting/schedule'})
    },
    setStartDt() {
      this.startCal = false
      if(!this.meeting.endDt) {
        this.meeting.endDt = this.meeting.startDt;
        // this.meeting.endDt = this.$moment(this.meeting.startDt).add(1, 'd').format('YYYY-MM-DD');
      }
    },
    setStartTm(ed) {
      this.meeting.endTm = `${parseInt(ed.data.HH, 10) < 23 ? String(parseInt(ed.data.HH, 10)+1).padStart(2, '0') : ed.data.HH}:${!ed.data.mm ? 'mm' : ed.data.mm}`;
    },
    async save() {

      // if(!this.meeting.startTm) {
      //   this.errStartTm = true;
      // }
      // if(!this.meeting.endTm) {
      //   this.errEndTm = true;
      // }
      if (!await this.$refs.formMeeting.validate())
        return;

      if(!this.meeting.groupId) {
        this.meeting.groupId = this.meeting.group.parentId;
      }

      this.meeting.meetingContents = this.$refs.meetingContents.getValue();

      if(!this.meeting.activated) {
        this.meeting.postDt = null;
      }

      if(this.meeting.startTm && typeof this.meeting.startTm === "object") {
        this.meeting.startTm = this.meeting.startTm.HH + ":" + this.meeting.startTm.mm + ":00"
      }
      if(this.meeting.endTm && typeof this.meeting.endTm === "object") {
        this.meeting.endTm = this.meeting.endTm.HH + ":" + this.meeting.endTm.mm + ":00"
      }

      meetingApi.save(this.meeting, this.files).then(data => {
        if (data) {
          if (this.meeting.meetingId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
          this.goList();
        } else {
          alert("Error");
        }
      });
    }

  },
  created() {
    if (this.$route.params.meetingId) {
      meetingApi.get(this.$route.params.meetingId).then(data => {
        // console.log(data);
        this.meeting = data;
        if(!this.meeting.group.parentId) {
          this.meeting.group.parentId = this.meeting.groupId;
        }
      });
    }


    groupApi.flatList().then(data => {
      this.rootGroups = data;
    });
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}
</style>